/* ==========================================================================
   ProductCardHe> Client > Prototype
   ========================================================================= */
/* Modules */
const { Store } = require('@bluekiri/alexandria/helpers/state');

const { types, actions } = require('./store/actions');
const { reducer } = require('./store/reducer');

const { initImages } = require('./image');

const { initNav } = require('./nav/modules');
const { initTooltip } = require('./tooltip/modules');
const { startModal, destroyModal } = require('./modal/modules');

const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            data: reducer
        });

        return this;
    },
    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => this.store.dispatch(actions.destroy()),
            setData: data => this.store.dispatch(actions.setData(data))
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe(async (state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Destroy */
                if (this.config.hasModal) await destroyModal(this);
                if (this.images.length) this.images.forEach(image => image.actions.destroy());
                if (this.navItems) this.navItems.forEach(button => button.actions.destroy());

                /* Unsubscribe */
                this.unsubscribe();
                [...Object.keys(this.reactions)].forEach(key => this.reactions[key].unsubscribe());

                /* Delete from DOM */
                this.element.parentNode.removeChild(this.element);

                /* Clean references */
                [...Object.keys(this)].forEach(key => delete this[key]);
            })
        };

        return this;
    },

    /* Subscribe */
    subscribe() {
        if (this.subscriptions) this.unsubscribe();

        this.subscriptions = {};

        return this;
    },
    /* Unsubscribe */
    unsubscribe() {
        if (!this.subscriptions) return this;

        [...Object.keys(this.subscriptions)].forEach(key => this.subscriptions[key].unsubscribe());

        return this;
    },

    start() {
        if (!this.config.start) return this;

        /* Sync store */
        this.actions.setData({ initialized: [0] });

        /* Star modal */
        if (this.config.hasModal) startModal(this);

        return this;
    },

    /* Init */
    init() {
        if (!this.config.init) return this;

        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Subscribe */
        this.subscribe();

        /* start */
        this.start();

        /* Init components */
        initImages(this);

        if (this.config.hasNavigation) initNav(this);

        if (this.config.hasIcons) initTooltip(this);

        return this;
    }
};

// Exports
module.exports = prototype;
